import CustomFieldService from './service';

export * from './reqres';

export default CustomFieldService;
